const IMAGE_WIDTH = 200;
const IMAGE_HEIGHT = 200;
const MAX_FILE_SIZE = 1000000; // 1MO

const uploadFileMixin = {
    data: () => {
        return {
            fileSrc: "",
            fileName: "",
            isDragOver: false,
            fileError: false,
            fileExtensionError: false,
            fileSizeError: false,
            fileImageMetricsError: false,
        };
    },

    mounted() {
        //prevent bind errors if form has no uploadFile components
        if(this.moduleInstance.formType == 'user') return

        // Check if drag is available
        this.hasDragOption = this.checkDragnDrop();

        // Events
        this.bindEvents();
        if (this.hasDragOption) {
            this.bindDragEvents();
        }

        // Run
        this.initPreview();
    },

    beforeDestroy() {
        //prevent bind errors if form has no uploadFile components
        if(this.moduleInstance.formType == 'user') return

        // Events
        this.unbindEvents();
        if (this.hasDragOption) {
            this.unbindDragEvents();
        }
    },

    methods: {
        /////////////////////////
        // Binding
        bindEvents() {
            this.resizeBind = this.onResize.bind(this);
            window.addEventListener("resize", this.resizeBind);
        },

        unbindEvents() {
            window.removeEventListener("resize", this.resizeBind);
        },

        bindDragEvents() {
            this.$refs.fileLabel.addEventListener("drag", this.preventDrag);
            this.$refs.fileLabel.addEventListener(
                "dragstart",
                this.preventDrag
            );
            this.$refs.fileLabel.addEventListener("dragend", this.onDragOut);
            this.$refs.fileLabel.addEventListener("dragover", this.onDragIn);
            this.$refs.fileLabel.addEventListener("dragenter", this.onDragIn);
            this.$refs.fileLabel.addEventListener("dragleave", this.onDragOut);
            this.$refs.fileLabel.addEventListener("drop", this.onDrop);
        },
        unbindDragEvents() {
            this.$refs.fileLabel.removeEventListener("drag", this.preventDrag);
            this.$refs.fileLabel.removeEventListener(
                "dragstart",
                this.preventDrag
            );
            this.$refs.fileLabel.removeEventListener("dragend", this.onDragOut);
            this.$refs.fileLabel.removeEventListener("dragover", this.onDragIn);
            this.$refs.fileLabel.removeEventListener(
                "dragenter",
                this.onDragIn
            );
            this.$refs.fileLabel.removeEventListener(
                "dragleave",
                this.onDragOut
            );
            this.$refs.fileLabel.removeEventListener("drop", this.onDrop);
        },

        /////////////////////////
        // Callbacks
        onDragIn(e) {
            this.preventDrag(e);
            this.isDragOver = true;
        },

        onDragOut(e) {
            this.preventDrag(e);
            this.isDragOver = false;
        },

        onDrop(e) {
            // Prevent event
            this.preventDrag(e);

            // Remove active css class
            this.isDragOver = false;

            // Reset file
            this.picture.src
                ? this.resetFile(false, false)
                : this.resetFile(false, true);

            // Get file
            if (!e.dataTransfer.files.length) {
                this.fileError = true;
                return;
            }
            const file = e.dataTransfer.files[0];

            // set image
            this.setImageSrc(file);
        },

        onInputFileChange(e) {
            // Reset file
            this.picture.src
                ? this.resetFile(false, false)
                : this.resetFile(false, true);

            // Get file
            if (!e.target.files.length) {
                this.fileError = true;
                return;
            }
            const file = e.target.files[0];

            // set image
            this.setImageSrc(file);
        },

        onResize() {
            this.$nextTick(() => {
                if (this.picture.src) {
                    this.computeWrapperHeight();
                }
            });
        },
        onResetFile(e) {
            e.preventDefault();
            this.resetFile(true);
        },

        /////////////////////////
        // Methods
        initPreview() {
            // Show preview
            if (this.picture.src) {
                this.animeTogglePreview(true);
            }
        },

        resetFile(rvalue = true, togglePreview = true) {
            if (rvalue) {
                this.$refs.fileInput.value = null;
            }

            if (togglePreview && this.picture.src) {
                this.animeTogglePreview(false);
            }

            this.fileError = false;
            this.fileExtensionError = false;
            this.fileSizeError = false;
            this.fileImageMetricsError = false;
        },

        setImageSrc(file) {
            // Get file name
            const fileName = file.name;

            // File extension
            let isFileExstensionValid = this.checkFileExtension(fileName);
            if (!isFileExstensionValid) return;

            // File size
            // let isFileValid = this.checkFileSize(file)
            // if(!isFileValid) return

            // Image size
            const imageFilePromise = this.getImageFile(file);

            // When image is loaded
            imageFilePromise.then((imageFile) => {
                // Check file metrics
                let isImageFileValid = this.checkImageFileMetrics(imageFile);
                if (!isImageFileValid) return;

                // Crop image and get src
                const fileSrc = this.cropImage(imageFile);

                // Set picture object
                this.setPictureValues &&
                    this.setPictureValues(fileName, fileSrc);

                // Then show preview
                this.animeTogglePreview(true);
            });
        },

        getImageFile(file) {
            return new Promise((resolve) => {
                const reader = new FileReader();
                reader.onload = () => {
                    const imageFile = new Image();
                    imageFile.onload = () => {
                        resolve(imageFile);
                    };
                    imageFile.src = reader.result;
                };
                reader.readAsDataURL(file);
            });
        },

        cropImage(image) {
            let aspectRadio = image.height / image.width;
            let newHeight = 0;
            let newWidth = 0;
            let xStart = 0;
            let yStart = 0;

            // Get Canvas
            if (!this.$canvas) {
                const $canvas = document.createElement("canvas");
                $canvas.width = IMAGE_WIDTH;
                $canvas.height = IMAGE_HEIGHT;
                this.$canvas = $canvas;
            }

            // Get context
            const canvasContext = this.$canvas.getContext("2d");

            // Compute metrics
            if (image.height < image.width) {
                aspectRadio = image.width / image.height;
                (newHeight = IMAGE_HEIGHT),
                    (newWidth = aspectRadio * IMAGE_HEIGHT);
                xStart = -(newWidth - IMAGE_WIDTH) / 2;
            } else {
                (newWidth = IMAGE_WIDTH),
                    (newHeight = aspectRadio * IMAGE_WIDTH);
                yStart = -(newHeight - IMAGE_HEIGHT) / 2;
            }

            // Draw canvas
            canvasContext.drawImage(image, xStart, yStart, newWidth, newHeight);

            // Export image
            return this.$canvas.toDataURL("image/jpeg", 1.0);
        },

        preventDrag(e) {
            e.preventDefault();
            e.stopPropagation();
        },

        computeWrapperHeight() {
            const $wrapperHeight = this.$refs.preview.offsetHeight;
            this.$refs.previewWrapper.style.height = `${$wrapperHeight}px`;
        },

        /////////////////////////
        // Checks
        checkFileSize(file) {
            if (file.size > MAX_FILE_SIZE) {
                this.fileSizeError = true;
                return false;
            }
            return true;
        },

        checkImageFileMetrics(imageFile) {
            if (
                imageFile.width < IMAGE_WIDTH ||
                imageFile.height < IMAGE_HEIGHT
            ) {
                this.fileImageMetricsError = true;
                return false;
            }
            return true;
        },

        checkFileExtension(filename) {
            if (!/\.(jpg|JPG|jpeg|JPEG|png|PNG)$/i.test(filename)) {
                this.fileExtensionError = true;
                return false;
            }
            return true;
        },

        checkDragnDrop() {
            return (function () {
                const div = document.createElement("div");
                return (
                    ("draggable" in div ||
                        ("ondragstart" in div && "ondrop" in div)) &&
                    "FormData" in window &&
                    "FileReader" in window
                );
            })();
        },

        /////////////////////////
        // Animations
        animeTogglePreview(isActive) {
            const $wrapperHeight = this.$refs.preview.offsetHeight;
            gsap.to(this.$refs.previewWrapper, 0.3, {
                height: isActive ? $wrapperHeight : 0,
                onComplete: () => {
                    if (!isActive) {
                        this.setPictureValues && this.setPictureValues("", "");
                    }
                    // this.moduleInstance && this.moduleInstance.call('update', null, 'Scroll')
                },
            });
        },
    },
};

export default uploadFileMixin;
